import React from 'react';

export default function RecordingHealth({ filename, health }) {
    const status = health && ['healthy', 'unhealthy'].includes(health.status) ? health.status : 'unknown';
    const label = { healthy: 'Healthy', unhealthy: 'Not healthy', unknown: 'Health unknown' }[status];
    const issues = health && Array.isArray(health.issues) ? health.issues : [];
    const description = status === 'healthy' ? 'Basic merge input checks passed. Full validation runs during merge.' :
        issues.length ? issues.join('; ') : 'Recording health could not be checked.';
    return <span role="img" tabIndex="0" aria-label={`${filename}: ${label}. ${description}`}
        title={`${label}: ${description}`} className={`atlasRecordingHealth atlasRecordingHealth--${status}`}>
        <span aria-hidden="true">{status === 'healthy' ? '✓' : status === 'unhealthy' ? '!' : '?'}</span>
        <span className="atlasRecordingHealthDetails" aria-hidden="true">{label}: {description}</span>
    </span>;
}
